import { addOfficeBrand } from "../../../../../actions/Utilities/OfficeBrand";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "../../../../../components/toastNotification";

const useAddOfficeBrand = () => {
  return useMutation(addOfficeBrand);
};
export default useAddOfficeBrand;
